import { render, staticRenderFns } from "./MessengerMessageListItem.vue?vue&type=template&id=1b17fdbf&scoped=true"
import script from "./MessengerMessageListItem.vue?vue&type=script&lang=js"
export * from "./MessengerMessageListItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b17fdbf",
  null
  
)

export default component.exports